import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import {Typography} from "@mui/material";
import {config} from "../../config";

const managerNames = config.managerNames;

export const DraftBiddingDialog = ({open, handleClose, player, onManagerChange, onBidAmountChange, bidError, helperText, onSubmitBid}) => {
    const rfaOwner = player.manager_name ? player.manager_name : null;
    return (
        <Dialog open={open} onClose={handleClose} closeAfterTransition={false}>
            <DialogTitle id="place-bid-dialog">
                {`${rfaOwner ? 'RFA: ' : ''}${player.first_name} ${player.last_name} - ${player.pos} - ${player.team}`}
            </DialogTitle>
            <DialogContent>
                {rfaOwner &&
                    <div style={{marginBottom: 30}}>
                        <DialogContentText>
                            Owner:
                        </DialogContentText>
                        <Typography variant="body1" color="inherit" display="inline" style={{marginLeft: 10}}>
                            {rfaOwner}
                        </Typography>
                    </div>
                }
                <DialogContentText>
                    Winning bid:
                </DialogContentText>
                <Autocomplete id="managerSelectionField" freeSolo style={{width: 290}} options={managerNames}
                              getOptionLabel={(m) => `${m}${m === rfaOwner ? ' (RFA owner)' : ''}`}
                              onChange={onManagerChange}
                              renderInput={(params) => (
                                  <TextField {...params} label="Manager" margin="normal" variant="outlined"/>
                              )}/>
                <TextField id="bidAmountField" label="Amount" variant="outlined" type="number"
                           onChange={onBidAmountChange} error={bidError} helperText={helperText}/>
                <Button variant="contained" type="submit" color="primary" onClick={onSubmitBid} style={{margin: 10}}>Submit</Button>
            </DialogContent>
        </Dialog>
    );
}